import { bindActionCreators, compose } from 'redux';
import { lazy } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as cBandActions from '../../../CBandPlans/actions';
import injectReducer from '../../../../utils/injectReducer';
import injectSaga from '../../../../utils/injectSaga';
import saga from '../../../CBandPlans/sagas';
import cBandReducer from '../../../CBandPlans/reducer';
import * as addressSearchActions from '../../../AddressSearch/actions';
import addressSearchSaga from '../../../AddressSearch/sagas.js';
import addressSearchReducer from '../../../AddressSearch/reducer';
import { filteredValue, filterBasedOnPlanId, isPrepaidNRFlow, filteredValueFor55 } from '../../../../components/Web/AddressSearch/constant.js';
import cartSaga from '../../../../services/Cart/sagas';
import cartReducer from '../../../../services/Cart/reducer';
import * as cartActions from '../../../../services/Cart/actions';
import { getCookie } from '../../../../components/common/Helpers';
import * as taggingActions from '../../../Common/Tagging.js/actions';
import taggingSaga from '../../../Common/Tagging.js/sagas';

const BroadBandFacts = lazy(() => import('../../../../components/Web/BroadBandFacts/index.js'));

const mapStateToProps = (state) => {
  const planDetails = state.cBandPlans ? state.cBandPlans?.plans?.output?.plans : {};
  const planFliter = state.AddressSearch?.setPlanFilter || getCookie('FilterPlan');
  let plan55Filter = getCookie('category');
  plan55Filter = plan55Filter.indexOf('55+') > -1;
  // debugger;
  const currentView = state.currentView || {};

  return {
    planDetails,
    currentView,
    planFliter,
    fccContentError: state?.cBandPlans?.fccContentError || false,
    fccContentValue: state?.cBandPlans?.fccContentValue || {},
    showError: state?.cBandPlans?.showError || false,
    parsedAddress: state?.AddressSearch?.parsedAddress,
    taxDetails: state?.AddressSearch?.taxDetails,
    fccLabel: {
      detailList: planFliter
        ? filterBasedOnPlanId(state?.AddressSearch?.fccLabelList, planFliter)
        : plan55Filter
        ? filteredValueFor55(state?.AddressSearch?.fccLabelList)
        : isPrepaidNRFlow()
        ? state?.AddressSearch?.fccLabelList
        : filteredValue(state?.AddressSearch?.fccLabelList),
      error: state?.AddressSearch?.fccError,
    },
    fccProspectLabel: {
      ProspectDetailList: state?.AddressSearch?.fccProspectPlansList,
      error: state?.AddressSearch?.fccProspectError,
    },

    updatedJsonWithTax: state?.AddressSearch?.updatedJsonWithTax,
    addressDetails: {
      suggestionList: state?.cartDetails?.availableAddress?.addresses || [],
      error: state?.cartDetails?.showAddressError || false,
    },
    usertypedAddress: state?.AddressSearch?.usertypedAddress || '',
    selectedDate: state?.AddressSearch?.selectedDate || '',
    userSelectedAddress: state?.AddressSearch?.userSelectedAddress || '',
    enableContinueButton: state?.AddressSearch?.enableContinueButton || false,
    retrieveZipCodeDetails: {
      details: state?.AddressSearch?.retrieveZipCodeSuccess,
      error: state?.AddressSearch?.retrieveZipCodeError,
    },
  };
};
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...cBandActions,
      ...addressSearchActions,
      ...cartActions,
      ...taggingActions,
    },
    dispatch,
  );
}
const withReducer = compose(
  injectReducer({ key: 'cBandPlans', reducer: cBandReducer }),
  injectReducer({ key: 'cartReducer', reducer: cartReducer }),
  injectReducer({ key: 'AddressSearch', reducer: addressSearchReducer }),
);

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);
const withSaga = compose(
  injectSaga({ key: 'cBandPlans', saga }),
  injectSaga({ key: 'cartSaga', saga: cartSaga }),
  injectSaga({ key: 'addressSearchSaga', saga: addressSearchSaga }),
  injectSaga({ key: 'taggingDetails', saga: taggingSaga }),
);

export default withRouter(
  compose(
    withSaga,
    withReducer,
    withConnect,
  )(BroadBandFacts),
);
